$(function(){
	$('.js-open-menu').on('click', function(){
		if ($('.js-menu').is('.open')) {
			unfixBody();
		} else {
			fixBody();
		}
		$(this).toggleClass('open');
		$('.js-menu').toggleClass('open');
		$('.js-open-search').toggleClass('hidden');
	});

	// $('.menu-item-has-children > a').on('click', function(e){
	// 	minWidth(screenMd, function(){}, function(){
	// 		e.preventDefault();
	// 	});
	// });

	// $('.menu-item-has-children > li > a').on('click', function(e){
	// 	minWidth(screenMd, function(){}, function(){
	// 		e.stopPropagation();
	// 	});
	// });

	// $('.menu-item-has-children').on('click', function(){
	// 	var $ul = $(this).find('ul');

	// 	minWidth(screenMd, function(){}, function(){
	// 		$ul.slideToggle();
	// 	});
	// });
});

